// extracted by mini-css-extract-plugin
export default {"hero-image":"content_hero-image__3Ncls","cta-box":"content_cta-box__NSQKQ","add-section":"content_add-section__d3f0D"};